module.exports = __webpack_public_path__ + "static/media/stedelijk.386c5739.jpg";